/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Density_SpaciousInputs */

const en_disp_density_spacious = /** @type {(inputs: Disp_Density_SpaciousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spacious`)
};

const de_disp_density_spacious = /** @type {(inputs: Disp_Density_SpaciousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luftig`)
};

/**
* | output |
* | --- |
* | "Spacious" |
*
* @param {Disp_Density_SpaciousInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_density_spacious = /** @type {((inputs?: Disp_Density_SpaciousInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Density_SpaciousInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_density_spacious(inputs)
	return en_disp_density_spacious(inputs)
});